document.addEventListener("DOMContentLoaded", function () {
    const menuPage = document.getElementById("page-menu-pill-list")
    const customCollapsible = document.querySelectorAll(".custom-collapsable")
    const menuDict = {}
    if (menuPage && !menuPage.firstChild && customCollapsible.length) {
        for (let i = 0; i < customCollapsible.length; i++) {
            const subheading = customCollapsible[i].getElementsByClassName("section-subheading")[0]
            if (subheading) {
                menuDict[subheading.id] = subheading.innerText
            }
        }
    }

    const getButton = (id, text) => {
        const aTag = document.createElement("a")
        aTag.setAttribute("class", "pill")
        aTag.setAttribute("href", `#${id}`)
        aTag.innerText = text
        aTag.addEventListener("click", (e) => {
            e.preventDefault()
            document.getElementById(id).scrollIntoView({
                behavior: "smooth"
            })
        })
        return aTag
    }

    for (const id in menuDict) {
        menuPage.appendChild(getButton(id, menuDict[id]))
    }
});
